module.exports = __webpack_public_path__ + "img/select.7e0a8945.svg";